Ext.define('SA.EditRankingGeographicUnitRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        if (this.model.attributesHaveNoCommonUnits()) {
            return 'There is no common geographic unit among the data variables selected for this ranking.';
        }

        var {commaList, htmlEncode} = Ext.util.Format,
            datasets = this.model.getDatasetsWithNoMatchingUnitsForLocation(),
            nameEls = datasets.map(SA.data.Datasets.getName).map(htmlEncode).map(name => `<strong>‘${name}’</strong>`);

        return `The data variables in the ${commaList(nameEls, 'and', 'dataset')} do not match any available geographic units of this ranking.`;
    },

    isBroken() {
        return !this.model.canSelectGeographicUnit();
    }
});